export default import.meta.ROLLDOWN_FILE_URL_3Uw3XUngRQNUvCPRrDEOAQ